module.exports = __webpack_public_path__ + "img/01d.ff33f0de.png";